import React from 'react';
import styles from '../Hero/Hero.module.css';
import heroEndStyles from './HeroEnd.module.css'; // New module for HeroEnd-specific styles

const Hero: React.FC = () => {
    return (
        <div className={heroEndStyles.heroEndContainer}>
            <div className={`align-items-center d-flex flex-column text-center`} style={{ height: '10vh', marginTop: '2em' }}>
                <div className={styles.textContainer}>
                    <h1 style={{ color: 'rgb(0, 0, 0)' }}>25 prosent til Redd barna</h1>
                </div>
            </div>
        </div>

    );
};

export default Hero;